import noodleApiClient from '@/tsClient/servers/noodleApi';
import type { CaseDataConflictsResponse } from '@/typings/api-models';

type Input = {
  caseId: string;
};

const getCaseDataConflicts = async ({ caseId }: Input): Promise<CaseDataConflictsResponse> => {
  const response = await noodleApiClient.get(`/cases/${caseId}/conflicts/details`);
  return response.data as CaseDataConflictsResponse;
};

export default getCaseDataConflicts;
